module.exports = __webpack_public_path__ + "62d6084868a61bc0a0a4110c158708c5.png";